var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FlatpageLegalBase", [
    _c(
      "p",
      { staticClass: "intro" },
      [
        _vm._v(
          "\n    This is a previous version of the Privacy Policy that was in effect from May 21, 2018 until\n    Jan 1, 2020.\n    "
        ),
        !_vm.isMobile(_vm.$mq) ? _c("br") : _vm._e(),
        _vm._v(" "),
        _c(
          "router-link",
          { attrs: { to: { name: "flatpage_privacypolicy" } } },
          [_vm._v("\n      View the current Privacy Policy\n    ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("h1", [_vm._v("1. Brilliant.org Privacy Statement")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    Brilliant Worldwide, Inc. ("Brilliant") knows that you care about how your personal\n    information is used and shared, and we take your privacy seriously. Please read the following\n    to learn more about our Privacy Statement. By using the brilliant.org website, or any of our\n    mobile applications (such as are available via the App Store and Google Play Store), and any\n    related services and/or features (collectively, the "Service") you acknowledge that you accept\n    the practices and policies outlined in this Privacy Statement. If you are a resident of the\n    European Union ("EU"), United Kingdom, Lichtenstein, Norway, or Iceland, you may have\n    additional rights under the EU General Data Protection Regulation (the "GDPR") with respect to\n    your Personal Information, as '
      ),
      _c("a", { attrs: { href: "#gdpr" } }, [_vm._v("outlined below")]),
      _vm._v(".\n  ")
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("2. What Does This Privacy Statement Cover?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    This Privacy Statement covers Brilliant\'s treatment of personally identifiable information\n    ("Personal Information") that Brilliant gathers when you access/use the Service.\n  '
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("3. What Personal Information Does Brilliant Collect?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    Brilliant collects information you voluntarily submit to the Service, such as, the information\n    we collect when you register for an account: your name, email address, school, date of birth,\n    etc.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    Information you elect to submit to the Service in a public or quasi-public manner may be\n    disclosed to other users of the Application or the general public ("User Submission(s)"). For\n    example–if you make a post to a message board or chat forum that includes any personal\n    information – such information will be made publicly available. We endeavor to make sure\n    the Service\'s functionality puts you on reasonable notice as to the scope of an intended\n    submission.\n  '
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    In addition, we may automatically receive and store certain, anonymous types of information\n    whenever you interact with the Service. Such information may include the user's IP address,\n    domain server, and type of Internet browser. This information helps us, among other things,\n    analyze trends and administer the Service. This information is anonymous and contains no\n    personally identifiable data.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Do Not Track Policy.")]),
      _vm._v(
        ' Through cookies we place on your browser or device, we may\n    collect information about your online activity after you leave our Services. Just like any\n    other usage information we collect, this information allows us to improve the Services and\n    customize your online experience, and otherwise as described in this Privacy Policy. Your\n    browser may offer you a "Do Not Track" option, which allows you to signal to operators of\n    websites and web applications and services (including behavioral advertising services) that\n    you do not wish such operators to track certain of your online activities over time and across\n    different websites. Our Services do not support Do Not Track requests at this time, which\n    means that we collect information about your online activity both while you are using the\n    Services and after you leave our Services.\n  '
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("4. What about children?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    The safety and privacy of children is extremely important to us. If you are a resident of the\n    EU, United Kingdom, Lichtenstein, Norway, or Iceland, then you must be 16 years old or older\n    to use the Services in any way. Otherwise, every user of the Service must be 13 years of age\n    or older. Any person that does not meet the foregoing age requirements is a "Minor". Minors\n    are prohibited from signing up or using the Service in any way. If you are a Minor, please do\n    not attempt to register for the Services or send any personal information about yourself to\n    us. If we learn that we have collected personal information from a Minor, we will delete that\n    information as quickly as possible. If you believe that a Minor may have provided us personal\n    information, please contact us at\n    '
      ),
      _c("a", { attrs: { href: "mailto:privacy@brilliant.org" } }, [
        _vm._v("privacy@brilliant.org")
      ]),
      _vm._v(
        ". We reserve the right to\n    require any user to verify that the user is not a Minor, and if a user does not provide such\n    verification in a timely manner, we will terminate the user's account and delete all\n    personally identifiable information displaying on the site and collected from such user.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h2", [
      _vm._v("5. How does Brilliant use the information it collects?")
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _vm._v(
          "\n      Provide the Service: Your information will be used primarily to provide you with the\n      Service.\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n      Improve the Service: Your information may be used by us internally to improve the Service\n      and develop new products, services and features.\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Other Uses: Your information may also be used by us as set forth in the next section."
        )
      ])
    ]),
    _vm._v(" "),
    _c("h2", [
      _vm._v(
        "6. Will Brilliant Share Any of the Personal Information it Receives?"
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    To the limited extent we collect Personal Information – we neither rent nor sell your\n    Personal Information to anyone. We share your Personal Information only as described below.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Recipient of User Submissions:")]),
      _vm._v(
        " As mentioned above – your User Submissions may\n    be shared in a public or quasi-public manner.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Service Providers and Agents:")]),
      _vm._v(
        " We employ other companies and people to perform tasks\n    on our behalf. For example, we may decide to use a third party payment processing company to\n    process payments you make through the Service. In addition, parts of the Service may be hosted\n    by a third party on our behalf. Your information may be accessed by such providers/agents, in\n    the event that we need to share your information with them to provide our services or customer\n    support to you. Unless we tell you differently, Brilliant's agents do not have any right to\n    use Personal Information we share with them beyond what is necessary to assist us.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Business Transfers:")]),
      _vm._v(
        " In some cases, we may choose to buy or sell assets. In these\n    types of transactions, customer information is typically one of the business assets that are\n    transferred. Moreover, if Brilliant, or substantially all of its assets were acquired, or in\n    the unlikely event that Brilliant goes out of business or enters bankruptcy, customer\n    information would be one of the assets that is transferred or acquired by a third party. You\n    acknowledge that such transfers may occur, and that any acquirer of Brilliant may continue to\n    use your Personal Information as set forth in this policy.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Protection of Brilliant and Others:")]),
      _vm._v(
        " We may release Personal Information when we\n    believe in good faith that release is necessary to comply with the law; enforce or apply our\n    conditions of use and other agreements; or protect the rights, property, or safety of\n    Brilliant, our employees, our users, or others.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("With Your Consent:")]),
      _vm._v(
        " Except as set forth above, you will be notified when your Personal\n    Information may be shared with third parties, and will be able to prevent the sharing of this\n    information.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("7. Conditions of Use")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    If you decide to access or use the Service, such access and use and any possible dispute over\n    privacy is subject to this Privacy Statement and our Terms of Use (located on our website),\n    including limitations on damages, disclaimer of warranties, and the application of California\n    state law.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("8. Third Party Websites/Services")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    The Site may permit you to link to other websites on the Internet, and other websites may\n    contain links to the Site. These other websites are not under Brilliant control, and such\n    links do not constitute an endorsement by Brilliant of those other websites or the services\n    offered through them. The privacy and security practices of websites linked to or from the\n    Service are not covered by this Privacy Statement, and Brilliant is not responsible for the\n    privacy or security practices or the content of such websites.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("9. Opting out of all future emails")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    If you would like to stop receiving email from Brilliant, simply visit the Email section of\n    your Account settings and uncheck any and all boxes.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("10. Privacy Shield")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    The Services are hosted and operated in the United States ("U.S.") through Brilliant and its\n    service providers, and if you do not reside in the U.S., laws in the U.S. may differ from the\n    laws where you reside. By using the Services, you acknowledge that any Personal Data about\n    you, regardless of whether provided by you or obtained from a third party, is being provided\n    to Brilliant in the U.S. and will be hosted on U.S. servers, and you authorize Brilliant to\n    transfer, store and process your information to and in the U.S., and possibly other countries.\n    You hereby consent to the transfer of your data to the U.S. pursuant to EU-US and\n    Swiss–US Privacy Shield Framework, the details of which are further set forth below.\n  '
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    Brilliant has certified to the EU.-U.S. and Swiss–US Privacy Shield Framework set forth\n    by the U.S. Department of Commerce regarding the collection and use of Personal Data\n    transferred from the EU and Switzerland. For more information about the Privacy Shield\n    Program, and to view Brilliant's certification, please visit\n    "
      ),
      _c(
        "a",
        { attrs: { href: "https://www.privacyshield.gov/", target: "_blank" } },
        [_vm._v("www.privacyshield.gov")]
      ),
      _vm._v(
        ". Brilliant\n    is committed to the Privacy Shield Principles of (1) notice, (2) consent, (3) accountability\n    for onward transfer, (4) security, (5) data integrity and purpose limitation, (6) access and\n    (7) recourse, enforcement and liability with respect to all Personal Data received from within\n    the EU and Switzerland in reliance on the Privacy Shield. The Privacy Shield Principles\n    require that we remain potentially liable if any third party processing subject Personal Data\n    on our behalf fails to comply with these Privacy Shield Principles (except to the extent we\n    are not responsible for the event giving rise to any alleged damage). Brilliant's compliance\n    with the Privacy Shield is subject to the investigatory and enforcement powers of the U.S.\n    Federal Trade Commission.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    Please contact us at\n    "),
      _c("a", { attrs: { href: "mailto:privacy+gdpr@brilliant.org" } }, [
        _vm._v("privacy+gdpr@brilliant.org")
      ]),
      _vm._v(
        " with any questions\n    or concerns relating to our Privacy Shield Certification. If you do not receive timely\n    acknowledgment of your Privacy Shield-related complaint from us, or if we have not resolved\n    your complaint, you may also resolve a Privacy Shield-related complaint through JAMS, an\n    alternative dispute resolution provider located in the United States. You can visit\n    "
      ),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://www.jamsadr.com/file-an-eu-us-privacy-shield-or-safe-harbor-claim",
            target: "_blank"
          }
        },
        [
          _vm._v(
            "https://www.jamsadr.com/file-an-eu-us-privacy-shield-or-safe-harbor-claim"
          )
        ]
      ),
      _vm._v(
        "\n    for more information or to file a complaint, at no cost to you. Under certain conditions, you\n    may also be entitled to invoke binding arbitration for complaints not resolved by other means.\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "anchor", attrs: { id: "gdpr" } }),
    _vm._v(" "),
    _c("h2", [_vm._v("11. GDPR")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    For this GDPR section, we use the terms "Personal Data" and "processing" as they are defined\n    in the GDPR, but "Personal Data" generally means information that can be used to individually\n    identify a person, and "processing" generally covers actions that can be performed in\n    connection with data such as collection, use, storage and disclosure. Brilliant will be the\n    controller of your Personal Data processed in connection with the Sites. Note that we may also\n    process Personal Data of our customers\' end users or employees in connection with our\n    provision of services to customers, in which case we are the processor of Personal Data. If we\n    are the processor of your Personal Data (i.e., not the controller), please contact the\n    controller party in the first instance to address your rights with respect to such data.\n  '
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    If there are any conflicts between this section and any other provision of this Privacy\n    Policy, the policy or portion that is more protective of Personal Data shall control to the\n    extent of such conflict. If you have any questions about this section or whether any of the\n    following applies to you, please contact us at\n    "
      ),
      _c("a", { attrs: { href: "mailto:privacy+gdpr@brilliant.org" } }, [
        _vm._v("privacy+gdpr@brilliant.org")
      ]),
      _vm._v(".\n  ")
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [
        _c("u", [_vm._v("What Personal Data Do We Collect From You?")])
      ]),
      _vm._v(
        " We collect Personal Data\n    about you when you provide such information directly to us, when third parties such as our\n    business partners or service providers provide us with Personal Data about you, or when\n    Personal Data about you is automatically collected in connection with your use of our Sites.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("u", [_vm._v("Information we collect directly from you:")]),
      _vm._v(
        " We receive Personal Data directly from you\n    when you provide us with such Personal Data, including without limitation the following:\n  "
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _vm._v("\n      Required:\n      "),
        _c("ul", [
          _c("li", [_vm._v("First and last name")]),
          _vm._v(" "),
          _c("li", [_vm._v("Email address")]),
          _vm._v(" "),
          _c("li", [_vm._v("Birthdate")]),
          _vm._v(" "),
          _c("li", [_vm._v("IP address(es)")])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("\n      Optional:\n      "),
        _c("ul", [
          _c("li", [_vm._v("Mailing address")]),
          _vm._v(" "),
          _c("li", [_vm._v("Telephone number")]),
          _vm._v(" "),
          _c("li", [_vm._v("Facts about education history and career")]),
          _vm._v(" "),
          _c("li", [_vm._v("General location")])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("p", [
      _c("u", [_vm._v("Information we receive from third party sources:")]),
      _vm._v(
        " Some third parties such as our\n    business partners and service providers provide us with Personal Data about you, such as the\n    following:\n  "
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("strong", [_vm._v("Account information for third party services:")]),
        _vm._v(
          " If you interact with a third\n      party service when using our Sites, such as if you use a third party service to log-in to\n      our Sites (e.g., Facebook, Google, or Twitter), or if you share content from our Sites\n      through a third party social media service, the third party service will send us information\n      about you, such as information from your public profile, if the third party service and your\n      account settings allow such sharing. The information we receive will depend on the policies\n      and your account settings with the third party service.\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", [
      _c("u", [
        _vm._v("Information we automatically collect when you use our Sites:")
      ]),
      _vm._v(
        " Some Personal Data is\n    automatically collected when you use our Sites, such as the following:\n  "
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [_vm._v("IP address")]),
      _vm._v(" "),
      _c("li", [_vm._v("Device identifiers")]),
      _vm._v(" "),
      _c("li", [_vm._v("Web browser information")]),
      _vm._v(" "),
      _c("li", [_vm._v("Page view statistics")]),
      _vm._v(" "),
      _c("li", [_vm._v("Browsing history")]),
      _vm._v(" "),
      _c("li", [_vm._v("Usage information")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n      Transaction information (e.g. transaction amount, date and time such transaction occurred)\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "li",
        [
          _vm._v(
            "\n      Cookies and other tracking technologies (e.g. web beacons, pixel tags, SDKs, etc.) —\n      For more information, please review our\n      "
          ),
          _c(
            "router-link",
            { attrs: { to: { name: "flatpage_cookiepolicy" } } },
            [_vm._v("Cookie Policy")]
          ),
          _vm._v(".\n    ")
        ],
        1
      ),
      _vm._v(" "),
      _c("li", [_vm._v("Location inferred from your IP address")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Log data (e.g. access times, hardware and software information)"
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [_c("u", [_vm._v("How Do We Use Your Personal Data?")])]),
      _vm._v(
        " We process Persona Data to operate,\n    improve, understand and personalize our Sites. For example, we use Personal Data to:\n  "
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [_vm._v("Create and manage user profiles")]),
      _vm._v(" "),
      _c("li", [_vm._v("Communicate with you about the Sites")]),
      _vm._v(" "),
      _c("li", [_vm._v("Process orders")]),
      _vm._v(" "),
      _c("li", [
        _vm._v("Contact you about Site announcements, updates or offers")
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("Provide support and assistance for the Sites")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Personalize website content and communications based on your preferences"
        )
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("Meet contract or legal obligations")]),
      _vm._v(" "),
      _c("li", [_vm._v("Respond to user inquiries")]),
      _vm._v(" "),
      _c("li", [_vm._v("Fulfill user requests")]),
      _vm._v(" "),
      _c("li", [_vm._v("Comply with our legal or contractual obligations")]),
      _vm._v(" "),
      _c("li", [_vm._v("Resolve disputes")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Protect against or deter fraudulent, illegal or harmful actions"
        )
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("Enforce our Terms and Conditions")])
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    We will only process your Personal Data if we have a lawful basis for doing so. Lawful bases\n    for processing include consent, contractual necessity and our "legitimate interests" or the\n    legitimate interest of others, as further described below.\n  '
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("strong", [_vm._v("Contractual Necessity:")]),
        _vm._v(
          ' We process the following categories of Personal Data\n      as a matter of "contractual necessity", meaning that we need to process the data to perform\n      under our Terms and Conditions with you, which enables us to provide you with the Sites.\n      When we process data due to contractual necessity, failure to provide such Personal Data\n      will result in your inability to use some or all portions of the Sites that require such\n      data.\n      '
        ),
        _c("ul", [
          _c("li", [_vm._v("First and last name")]),
          _vm._v(" "),
          _c("li", [_vm._v("Email address")]),
          _vm._v(" "),
          _c("li", [_vm._v("Birthdate")]),
          _vm._v(" "),
          _c("li", [_vm._v("Mailing address")]),
          _vm._v(" "),
          _c("li", [_vm._v("Telephone number")]),
          _vm._v(" "),
          _c("li", [_vm._v("Facts about education history and career")]),
          _vm._v(" "),
          _c("li", [_vm._v("General location")])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Legitimate Interest:")]),
        _vm._v(
          " We process the following categories of Personal Data\n      when we believe it furthers the legitimate interest of us or third parties.\n      "
        ),
        _c("ul", [
          _c("li", [_vm._v("First and last name")]),
          _vm._v(" "),
          _c("li", [_vm._v("Email address")]),
          _vm._v(" "),
          _c("li", [_vm._v("Birthdate")]),
          _vm._v(" "),
          _c("li", [_vm._v("IP address(es)")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n          Examples of these legitimate interests include:\n          "
            ),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Operation and improvement of our business, products and services"
                )
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("Marketing of our products and services")]),
              _vm._v(" "),
              _c("li", [_vm._v("Provision of customer support")]),
              _vm._v(" "),
              _c("li", [_vm._v("Protection from fraud or security threats")]),
              _vm._v(" "),
              _c("li", [_vm._v("Compliance with legal obligations")]),
              _vm._v(" "),
              _c("li", [_vm._v("Completion of corporate transactions")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Consent:")]),
        _vm._v(
          " In some cases, we process Personal Data based on the consent you\n      expressly grant to us at the time we collect such data. When we process Personal Data based\n      on your consent, it will be expressly indicated to you at the point and time of collection.\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Other Processing Grounds:")]),
        _vm._v(
          " From time to time we may also need to process\n      Personal Data to comply with a legal obligation, if it is necessary to protect the vital\n      interests of you or other data subjects, or if it is necessary for a task carried out in the\n      public interest.\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [
        _c("u", [_vm._v("How and With Whom Do We Share Your Data?")])
      ]),
      _vm._v(
        " We share Personal Data with\n    vendors, third party service providers and agents who work on our behalf and provide us with\n    services related to the purposes described in this Privacy Policy or our Terms and Conditions.\n    These parties include:\n  "
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [_vm._v("Payment processors")]),
      _vm._v(" "),
      _c("li", [_vm._v("Ad networks")]),
      _vm._v(" "),
      _c("li", [_vm._v("Analytics service providers")]),
      _vm._v(" "),
      _c("li", [_vm._v("Services to provide customer support")]),
      _vm._v(" "),
      _c("li", [_vm._v("Hosting service providers")])
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    We also share Personal Data when necessary to complete a transaction initiated or authorized\n    by you or provide you with a product or service you have requested. In addition to those set\n    forth above, these parties also include:\n  "
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _vm._v(
          "\n      Other users (where you post information publicly or as otherwise necessary to effect a\n      transaction initiated or authorized by you through the Sites)\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Social media services (if you interact with them through your use of the Sites)"
        )
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("Other parties authorized by you")])
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    We also share information with third parties when you have given us consent to do so (as\n    indicated at the point such information is collected).\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("We also share Personal Data when we believe it is necessary to:")
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _vm._v(
          "\n      Comply with applicable law or respond to valid legal process, including from law enforcement\n      or other government agencies\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n      Protect us, our business or our users, for example to enforce our Terms and Conditions,\n      prevent spam or other unwanted communications and investigate or protect against fraud\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("Maintain the security of our products and services")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Provide a service directly authorized and requested by you, the end user"
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    Furthermore, if we choose to buy or sell assets, user information is typically one of the\n    transferred business assets. Moreover, if we, or substantially all of our assets, were\n    acquired, or if we go out of business or enter bankruptcy, user information would be one of\n    the assets that is transferred or acquired by a third party, and we would share Personal Data\n    with the party that is acquiring our assets. You acknowledge that such transfers may occur,\n    and that any acquirer of us or our assets may continue to use your Personal Information as set\n    forth in this policy.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [
        _c("u", [_vm._v("How Long Do We Retain Your Personal Data?")])
      ]),
      _vm._v(
        " We retain Personal Data\n    about you as long as you have an open account with us or as otherwise necessary to provide you\n    Services. In some cases we retain Personal Data for longer, if doing so is necessary to comply\n    with our legal obligations, resolve disputes or collect fees owed, or is otherwise permitted\n    or required by applicable law, rule or regulation. Afterwards, we retain some information in a\n    depersonalized or aggregated form but not in a way that would identify you personally.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [_c("u", [_vm._v("What Security Measures Do We Use?")])]),
      _vm._v(
        " We seek to protect Personal Data\n    using appropriate technical and organizational measures based on the type of Personal Data and\n    applicable processing activity. For example, we encrypt all data in-transit, obfuscate and\n    anonymize data that we share with processors like analytics services, and maintain all\n    services with security patches in a timely manner. We also require that our suppliers protect\n    such information from unauthorized access, use, and disclosure.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [_c("u", [_vm._v("Personal Data of Children:")])]),
      _vm._v(
        " We do not knowingly collect or solicit\n    Personal Data from anyone under the age of 16. If you are under 16, please do not attempt to\n    register for the Sites or send any Personal Data about yourself to us. If we learn that we\n    have collected Personal Data from a child under age 16, we will delete that information as\n    quickly as possible. If you believe that a child under 16 may have provided us Personal Data,\n    please contact us at\n    "
      ),
      _c("a", { attrs: { href: "mailto:privacy+gdpr@brilliant.org" } }, [
        _vm._v("privacy+gdpr@brilliant.org")
      ]),
      _vm._v(".\n  ")
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [
        _c("u", [
          _vm._v("What Rights Do You Have Regarding Your Personal Data?")
        ])
      ]),
      _vm._v(
        " You have certain\n    rights with respect to your Personal Data, including those set forth below. For more\n    information about these rights, or to submit a request, please email\n    "
      ),
      _c("a", { attrs: { href: "mailto:privacy+gdpr@brilliant.org" } }, [
        _vm._v("privacy+gdpr@brilliant.org")
      ]),
      _vm._v(
        ". Please note that\n    in some circumstances, we may not be able to fully comply with your request, such as if it is\n    frivolous or extremely impractical, if it jeopardizes the rights of others, or if it is not\n    required by law, but in those circumstances, we will still respond to notify you of such a\n    decision. In some cases, we may also need to you to provide us with additional information,\n    which may include Personal Data, if necessary to verify your identity and the nature of your\n    request.\n  "
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c(
        "li",
        [
          _c("strong", [_vm._v("Access:")]),
          _vm._v(
            " You can request more information about the Personal Data we hold\n      about you and request a copy of such Personal Data. You can also access your Personal Data\n      by visiting\n      "
          ),
          _c(
            "router-link",
            { attrs: { to: { name: "personal_data_export_page" } } },
            [_vm._v("\n        Account settings > Export your data ")]
          ),
          _vm._v(".\n    ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("strong", [_vm._v("Rectification:")]),
          _vm._v(
            " If you believe that any Personal Data we are holding about\n      you is incorrect or incomplete, you can request that we correct or supplement such data. In\n      certain circumstances, you can correct some of this information directly by either updating\n      directly in the relevant\n      "
          ),
          _c(
            "router-link",
            { attrs: { to: { name: "personal_data_export_page" } } },
            [_vm._v("\n        Account settings > Export your data ")]
          ),
          _vm._v(".\n    ")
        ],
        1
      ),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Erasure:")]),
        _vm._v(
          " You can request that we erase some or all of your Personal Data\n      from our systems.\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Withdrawal of Consent:")]),
        _vm._v(
          " If we are processing your Personal Data based on\n      your consent (as indicated at the time of collection of such data), you have the right to\n      withdraw your consent at any time. Please note, however, that if you exercise this right,\n      you may have to then provide express consent on a case-by-case basis for the use or\n      disclosure of certain of your Personal Data, if such use or disclosure is necessary to\n      enable you to utilize some or all of our Sites.\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Portability:")]),
        _vm._v(
          " You can ask for a copy of your Personal Data in a\n      machine-readable format. You can also request that we transmit the data to another\n      controller where technically feasible.\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Objection:")]),
        _vm._v(
          " You can contact us to let us know that you object to the further\n      use or disclosure of your Personal Data for certain purposes.\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Restriction of Processing:")]),
        _vm._v(
          " You can ask us to restrict further processing of\n      your Personal Data.\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [_vm._v("Right to File Complaint:")]),
      _vm._v(
        " You have the right to lodge a complaint about\n    Brilliant's practices with respect to your Personal Data with the supervisory authority of\n    your country or EU Member State.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("12. Changes to this Privacy Statement")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    Brilliant may amend this Privacy Statement from time to time. Use of information we collect\n    now is subject to the Privacy Statement in effect at the time such information is used. If we\n    make changes in the way we use Personal Information, we will notify you by posting an\n    announcement on our website, or via the Service, or sending you an email. Users are bound by\n    any changes to the Privacy Statement when he or she uses the Service after such changes have\n    been first posted.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("13. Questions or Concerns")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    If you have any questions or concerns regarding privacy, please send us a detailed message at\n    "
      ),
      _c("a", { attrs: { href: "mailto:privacy@brilliant.org" } }, [
        _vm._v("privacy@brilliant.org")
      ]),
      _vm._v(". We will make every effort to\n    resolve your concerns.\n  ")
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Effective Date: May 21, 2018")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "em",
        [
          _vm._v(
            "\n      The previous version of this document is located\n      "
          ),
          _c(
            "router-link",
            { attrs: { to: { name: "flatpage_privacypolicy_03_24_2014" } } },
            [_vm._v("here")]
          ),
          _vm._v(".\n    ")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }